import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AgentAvailabilityResponse, AgentPresenceStatus } from '../models/call-routing.model';

export interface AgentAvailabilityUpdateRequest {
  presenceStatus: AgentPresenceStatus;
  maxConcurrentCalls?: number;
}

@Injectable({ providedIn: 'root' })
export class CallAvailabilityApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/calls/availability`;

  /** Estado de disponibilidad del agente actual. */
  getMyAvailability(): Observable<AgentAvailabilityResponse> {
    return this.http.get<AgentAvailabilityResponse>(this.base);
  }

  /** Actualiza la presencia del agente autenticado. */
  updateMyAvailability(req: AgentAvailabilityUpdateRequest): Observable<AgentAvailabilityResponse> {
    return this.http.patch<AgentAvailabilityResponse>(this.base, req);
  }

  /** Lista la disponibilidad de TODOS los agentes del business. */
  listBusinessAgents(): Observable<AgentAvailabilityResponse[]> {
    return this.http.get<AgentAvailabilityResponse[]>(`${this.base}/agents`);
  }

  /** Lista solo los agentes con presencia AVAILABLE. */
  listAvailableAgents(): Observable<AgentAvailabilityResponse[]> {
    return this.http.get<AgentAvailabilityResponse[]>(`${this.base}/available`);
  }

  /** Resuelve la disponibilidad de un user / team específico. */
  resolveAvailability(opts: { userId?: number; teamId?: number }): Observable<AgentAvailabilityResponse> {
    let params = new HttpParams();
    if (opts.userId != null) params = params.set('userId', opts.userId.toString());
    if (opts.teamId != null) params = params.set('teamId', opts.teamId.toString());
    return this.http.post<AgentAvailabilityResponse>(`${this.base}/resolve`, {}, { params });
  }
}
